import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { common } from "./locales/en/index.js";

// One language for now. The scaffolding is here because the vocabulary — not
// the language — is what varies: see the `subject` keys in the locale bundle.
export const resources = {
  en: {
    translation: common,
  },
};

void i18n.use(initReactI18next).init({
  resources,
  ns: ["translation"],
  defaultNS: "translation",
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false, // React already escapes rendered output
  },
});

export default i18n;
